<template>
    <div class="Avatar" :style="style" />
</template>

<script>
import profileIcon from '@/assets/images/profile.png';

export default {
    props: {
        color: {
            type: String,
            default: ''
        },
        avatar: {
            type: String,
            default: ''
        }
    },
    computed: {
        style() {
            return {
                backgroundImage: `url(${this.avatar}), url(${this.defaultProfileImage})`
            };
        },
        defaultProfileImage() {
            return profileIcon;
        }
    }
};
</script>

<style lang="scss" scoped>
.Avatar {
    border-radius: 50%;
    background-color: gray;

    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}
</style>
